import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ja: {
    translation: {
      いいね数: '{{val}}件のいいね',
      同じ事象あり数: '{{val}}件の同じ事象あり',
      の詳しく聞きたい数: '{{val}}件の詳しく聞きたい',
      コメント数: '{{val}}件のコメント',
      リツイート数: '{{val}}件のリツイート',
      同じカテゴリの投稿があります: '同じカテゴリの投稿が {{val}}件 あります',
      ja: '日本語',
      en: '英語',
    },
  },
  en: {
    translation: {
      // TODO: add english resources
      いいね数: '{{val}}件のいいね',
      同じ事象あり数: '{{val}}件の同じ事象あり',
      の詳しく聞きたい数: '{{val}}件の詳しく聞きたい',
      コメント件数: '{{val}} comments',
      ja: 'Japanese',
      en: 'English',
    },
  },
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(initReactI18next).init({
  resources,
  lng: 'ja',
  fallbackLng: 'ja',
  interpolation: {
    escapeValue: false,
  },
  keySeparator: '>>',
  nsSeparator: '||',
});
